<template>
  <div>
    <q-card>
      <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />
      <tela-monitora
        ref="refTelaMonitora"
        :paginaStatus="paginaStatus"
      />
      <q-card-main>
        <q-card
          inline
          color="green"
          style="width: 300px; height: 120px;"
        >
          <q-item>
            <q-item-side>
              <q-item-tile
                color="white"
                icon="fas fa-calendar"
              />
            </q-item-side>
            <q-item-main>
              <q-item-tile label>Processos abertos hoje</q-item-tile>
            </q-item-main>
          </q-item>
          <q-card-title>
            <q-btn
              align="right"
              flat
              class="full-width text-right mrg-t-20"
              style="color: #fff;"
              :label="qtdProcessosAbertoHoje"
              @click="pesquisarAbertosHoje"
            />
          </q-card-title>
        </q-card>
        <q-card
          inline
          color="orange"
          style="width: 300px; height: 120px;"
        >
          <q-item>
            <q-item-side>
              <q-item-tile
                color="white"
                icon="fas fa-globe-americas"
              />
            </q-item-side>
            <q-item-main>
              <q-item-tile label>Solicitações via internet que viraram processo</q-item-tile>
            </q-item-main>
          </q-item>
          <q-card-title>
            <!-- <div class="text-right mrg-t-10">{{this.qtdSolicitacaoProcesso}}</div> -->
            <q-btn
              align="right"
              flat
              class="full-width text-right"
              style="color: #fff; margin-top: 5px;"
              :label="qtdSolicitacaoProcesso"
              @click="pesquisarSolicitacaoProcesso"
            />
          </q-card-title>
        </q-card>
        <q-card
          inline
          color="blue"
          style="width: 300px;  height: 120px;"
        >
          <q-item>
            <q-item-side>
              <q-item-tile
                color="white"
                icon="fas fa-folder-open"
              />
            </q-item-side>
            <q-item-main>
              <q-item-tile label>Processos abertos via balcão</q-item-tile>
            </q-item-main>
          </q-item>
          <q-card-title>
            <!-- <div class="text-right mrg-t-20">{{this.qtdProcessosAbertoViaBalcao}}</div> -->
            <q-btn
              align="right"
              flat
              class="full-width text-right mrg-t-20"
              style="color: #fff;"
              :label="qtdProcessosAbertoViaBalcao"
              @click="pesquisarViaBalcao"
            />
          </q-card-title>
        </q-card>
        <div class="row">
          <div class="col-sm-2 col-xs-2">
            <g-input
              id="refNumProcessoInicial"
              name="refNumProcessoInicial"
              ref="refNumProcessoInicial"
              validacao="Number"
              mascara="numero"
              :tamanho="10"
              etiqueta="Nº do processo"
              :foco="false"
              v-model="aberturaProcesso.numProcesso"
            >
            </g-input>
          </div>
          <div class="col-sm-2 col-xs-2">
            <g-input
              id="refTxtProcesso"
              name="refTxtProcesso"
              ref="refTxtProcesso"
              validacao="Number"
              :tamanho="40"
              etiqueta="Nota Fiscal"
              :foco="false"
              v-model="aberturaProcesso.txtNotaFiscal"
            ></g-input>
          </div>
          <div class="col-sm-8 col-xs-8">
            <g-autocomplete
              id="refRequerente"
              name="refRequerente"
              ref="refRequerente"
              etiqueta="Requerente"
              valor="codRequerente"
              :foco="false"
              descricaoPrimaria="nomeDataNascimentoDocumento"
              :desabilitar="paginaStatus.desabilitarEdicao"
              :api=apiRequerente
              v-model="aberturaProcesso.requerente.codRequerente"
            >
            </g-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-xs-6">
            <g-autocomplete
              id="refAssunto"
              name="refAssunto"
              ref="refAssunto"
              etiqueta="Assunto"
              valor="codAssunto"
              descricaoPrimaria="desAssunto"
              :api=apiAssunto
              v-model="codAssunto"
            >
            </g-autocomplete>
          </div>
          <div class="col-sm-6 col-xs-6">
            <g-autocomplete
              id="refSubAssunto"
              name="refSubAssunto"
              ref="refSubAssunto"
              etiqueta="Subassunto"
              valor="codSubassunto"
              descricaoPrimaria="desSubassunto"
              :api="codAssunto !== '' ? apiSubAssuntoTermo : apiSubAssunto"
              :filtroAdicional="getFiltroSubassunto"
              v-model="codSubassunto"
            >
            </g-autocomplete>
          </div>
        </div>
        <div class="col-6 text-left mrg-t-10">
          <!-- Botão de Pesquisar e Limpar -->
          <q-btn
            icon="fa fa-search"
            style="background: #550059 !important; color: white"
            @click="pesquisarTodos"
          >
            &ensp;&ensp;Pesquisar
          </q-btn>
          &ensp;&ensp;
          <q-btn
            icon="fa fa-eraser"
            @click="limparFiltros"
          >
            &ensp;&ensp;Limpar
          </q-btn>
        </div>
      </q-card-main>
    </q-card>
    <g-datatable
      id="refResultadoPesquisaAberturaProcesso"
      name="refResultadoPesquisaAberturaProcesso"
      ref="refResultadoPesquisaAberturaProcesso"
      v-model="pagina"
      :colunas=colunasAberturaProcessoDataTable
      :operacoes=operacoes
      :api=apiaberturaProcesso
      :getFiltroPesquisa="getFiltroPesquisa"
      :elementosPorPagina=elementosPorPagina
      :exibirColunaOperacoes="true"
      :carregamentoInicial="false"
      :scrollHorizontal="false"
    />
  </div>
</template>

<script>
import api from 'components/util/api'
import util from 'components/util/util'
import GDatatable from 'components/util/gDatatable'
import GAutocomplete from 'components/util/gAutocomplete'
import GSelect from 'components/util/gSelect'
import GInput from 'components/util/gInput'
import GFab from 'components/util/gFab'
import utilHttp from 'components/util/utilHttp'
import TelaMonitora from 'components/telaMonitora/index'
import GBreadcrumb from 'components/util/gBreadcrumb'
export default {
  name: 'PageIndex',
  data () {
    return {
      apiRequerente: api.REQUERENTE,
      apiaberturaProcesso: api.ABERTURA_PROCESSO_BUSCAR_TODOS_PAGINADO,
      apiParametrosSistema: api.PARAMETROS_SISTEMA,
      apiAssunto: api.ASSUNTO,
      apiSubAssuntoTermo: api.SUB_ASSUNTO_COD_ASSUNTO,
      apiSubAssunto: api.SUB_ASSUNTO.concat('/todos'),
      elementosPorPagina: 10,
      pagina: 1,
      qtdProcessosAbertoHoje: 0,
      qtdSolicitacaoProcesso: 0,
      qtdProcessosAbertoViaBalcao: 0,
      termo: '',
      permissaoHome: '',
      indTipoBusca: '',
      codAssunto: '',
      codSubassunto: '',
      aberturaProcesso: {
        codAssunto: '',
        requerente: {}
      },
      paginaStatus: {
        nomeDataNascimentoDocumento: '',
        aberturaProcesso: {
          formaSolicitacao: {},
          justificativa: {},
          tipoProcesso: {},
          subassunto: { assunto: {} },
          roteiro: {}
        },
        documentoAnexoProcessoSalvarList: [],
        documentoAnexoProcessoExcluirList: [],
        caminhoMigalha: [
          {
            icone: '',
            descricao: '',
            rotaNome: ''
          }
        ]
      },
      colunasAberturaProcessoDataTable: [
        {
          conteudoTipo: '',
          largura: '5%',
          cabecalhoClasse: 'text-left',
          conteudoClasse: 'text-left',
          cabecalhoEtiqueta: 'Processo',
          propriedade: 'aberturaProcesso.numProcesso',
          chave: 'aberturaProcesso.numProcesso'
        },
        {
          conteudoTipo: '',
          largura: '5%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Ano',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.anoProcesso'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Status atual',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.indStatusProcesso'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Data atualização',
          conteudoClasse: 'text-left',
          propriedade: 'movimentacaoProcesso.datCriacaoOuAlteracao',
          formatar: (valor) => this.formatarDataAtualizacao(valor)
        },
        {
          conteudoTipo: '',
          largura: '25%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Requerente',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.requerente.nomeDocumento'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Situação',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.desSituacao'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Setor atual',
          conteudoClasse: 'text-left',
          propriedade: 'movimentacaoProcesso.setorConfirmacao.desSetor'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nota fiscal',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.txtNotaFiscal'
        }
      ],
      operacoes: [
        {
          cor: 'blue',
          icone: 'fas fa-search',
          tooltip: 'Visualizar',
          clique: this.visualizarItem,
          permissao: (row) => true,
          visivel: (row) => true
        }
      ]
    }
  },
  methods: {
    async buscarListaObservacaoProcesso (codProcesso) {
      return new Promise(resolve => {
        let filtro = '?codProcesso='.concat(codProcesso)
        utilHttp.httpGet(api.OBSERVACAO_GERAL_PROCESSO_LISTA.concat(filtro), resposta => {
          return resolve(resposta.body)
        })
      })
    },
    async buscarMovimentacaoDoProcesso (codProcesso) {
      return new Promise(resolve => {
        var filtro = '?codProcesso='.concat(codProcesso)
        utilHttp.httpGet(api.BUSCAR_MOVIMENTACAO_DO_PROCESSO.concat(filtro), resposta => {
          return resolve(resposta.body)
        })
      })
    },
    async buscarListaPendencias (numProcesso, anoProcesso) {
      return new Promise(resolve => {
        if (numProcesso && anoProcesso) {
          var filtro = ''.concat('?numProcesso=').concat(numProcesso).concat('&anoProcesso=').concat(anoProcesso)
          utilHttp.httpGet(api.PENDENCIA_PROCESSO_PROCESSO.concat(filtro), resposta => {
            var listaPendenciaProcesso = resposta.body
            listaPendenciaProcesso.forEach(item => {
              item.desSetorPendencia = item.indLocalPendencia === 'INT' ? item.movimentacaoProcesso.setorConfirmacao.desSetor : item.movimentacaoProcesso.aberturaProcesso.requerente.nomRequerente
            })
            return resolve(listaPendenciaProcesso)
          })
        } else {
          return resolve([])
        }
      })
    },
    async buscarListaDocumentoNecessario (codTipoProcesso, codAssunto, codSubassunto) {
      return new Promise(resolve => {
        if (codTipoProcesso && codAssunto && codSubassunto) {
          let filtro = ''.concat('?codTipoProcesso=').concat(codTipoProcesso).concat('&codAssunto=').concat(codAssunto).concat('&codSubassunto=').concat(codSubassunto)
          utilHttp.httpGet(api.DOCUMENTACAO_NECESSARIA_TIPO_PROCESSO_E_ASSUNTO_SUBASSUNTO.concat(filtro), resposta => {
            return resolve(resposta.body)
          })
        } else {
          return resolve([])
        }
      })
    },
    async buscarListaDadosAnexadosProcesso (codProcesso) {
      return new Promise(resolve => {
        if (codProcesso) {
          let filtro = ''.concat('/').concat(codProcesso)
          utilHttp.httpGet(api.BUSCAR_DOCUMENTO_ANEXO_PROCESSO_PELO_COD_PROCESSO.concat(filtro), resposta => {
            if (resposta.body.length > 0) {
              var listaDocumentosAnexoProcesso = resposta.body.filter(x => x.indAnexadoAbertura !== 'S')
              return resolve(listaDocumentosAnexoProcesso)
            } else {
              return resolve([])
            }
          })
        } else {
          return resolve([])
        }
      })
    },
    async buscarDocumentosAnexadosPortal (idProtocoloSolicitacao) {
      return new Promise(resolve => {
        if (idProtocoloSolicitacao) {
          let filtro = '?id='.concat(idProtocoloSolicitacao)
          utilHttp.httpGet(api.PROTOCOLO_SOLICITACAO_MOVIMENTACAO_DOCUMENTOS.concat(filtro), resposta => {
            return resolve(resposta.body.filter(x => x.indAnexadoAbertura !== 'S'))
          })
        } else {
          return resolve([])
        }
      })
    },
    async buscarDocumentosAnexadosAbertura (codProcesso) {
      return new Promise(resolve => {
        if (codProcesso) {
          var filtro = '/'.concat(codProcesso)
          utilHttp.httpGet(api.BUSCAR_DOCUMENTO_ANEXO_PROCESSO_PELO_COD_PROCESSO.concat(filtro), resposta => {
            return resolve(resposta.body.filter(x => x.indAnexadoAbertura === 'S'))
          })
        } else {
          return resolve([])
        }
      })
    },
    async montarListaDadosAnexadosSolicitacao (arrayAnexadoPortal, arrayAnexadoAbertura) {
      return new Promise(resolve => {
        if (arrayAnexadoPortal.length > 0 || arrayAnexadoAbertura.length > 0) {
          let protocoloSolicitacaoMovimentacaoLista = []
          arrayAnexadoAbertura.forEach(item => {
            if (protocoloSolicitacaoMovimentacaoLista.filter(x => x.nomDocumento === item.nomDocumento).length === 0) {
              let documentoSelecionado = item
              documentoSelecionado.documento = {
                nomDocumento: item.nomDocumento,
                arquivo: null
              }
              documentoSelecionado.tamanhoArquivo = item.tamanhoArquivo
              documentoSelecionado.indDisponibilidade = 'INT'
              protocoloSolicitacaoMovimentacaoLista.push(documentoSelecionado)
            }
          })
          arrayAnexadoPortal.forEach(item => {
            if (protocoloSolicitacaoMovimentacaoLista.filter(x => x.documento.nomDocumento === item.servidorArquivo.nomeArquivo).length === 0) {
              let documentoSelecionado = item
              documentoSelecionado.documento = {
                nomDocumento: item.servidorArquivo.nomeArquivo,
                arquivo: null
              }
              documentoSelecionado.tamanhoArquivo = item.servidorArquivo.tamanho
              documentoSelecionado.indDisponibilidade = 'INT'
              protocoloSolicitacaoMovimentacaoLista.push(documentoSelecionado)
            }
          })
          setTimeout(() => {
            return resolve(protocoloSolicitacaoMovimentacaoLista)
          }, 250)
        } else {
          return resolve([])
        }
      })
    },
    async visualizarItem (item) {
      var self = this
      util.mostrarCarregando()
      let arrayObservacaoProcesso = await self.buscarListaObservacaoProcesso(item.movimentacaoProcesso.aberturaProcesso.codProcesso)
      let arrayMovimentacaoProcesso = await self.buscarMovimentacaoDoProcesso(item.movimentacaoProcesso.aberturaProcesso.codProcesso)
      let arrayPendencias = await self.buscarListaPendencias(item.movimentacaoProcesso.aberturaProcesso.numProcesso, item.movimentacaoProcesso.aberturaProcesso.anoProcesso)
      let arrayDocumentosNecessarios = await self.buscarListaDocumentoNecessario(item.aberturaProcesso.tipoProcesso.codTipoProcesso, item.aberturaProcesso.subassunto.assunto.codAssunto, item.aberturaProcesso.subassunto.codSubassunto)
      let arrayDadosAnexadosProcesso = await self.buscarListaDadosAnexadosProcesso(item.aberturaProcesso.codProcesso)
      let arrayAnexadoPortal = await self.buscarDocumentosAnexadosPortal(item.aberturaProcesso.idProtocoloSolicitacao)
      let arrayAnexadoAbertura = await self.buscarDocumentosAnexadosAbertura(item.aberturaProcesso.codProcesso)
      let arrayDadosAnexadosSolicitacao = await self.montarListaDadosAnexadosSolicitacao(arrayAnexadoPortal, arrayAnexadoAbertura)
      if (arrayObservacaoProcesso && arrayMovimentacaoProcesso && arrayPendencias && arrayDocumentosNecessarios && arrayDadosAnexadosProcesso && arrayDadosAnexadosSolicitacao) {
        util.esconderCarregando()
        self.$refs['refTelaMonitora'].carregarComponente(item, arrayObservacaoProcesso, arrayMovimentacaoProcesso, arrayPendencias, arrayDocumentosNecessarios, arrayDadosAnexadosProcesso, arrayDadosAnexadosSolicitacao)
      }
    },
    getFiltroSubassunto () {
      var filtro = ''
      filtro = filtro.concat('/').concat(this.codAssunto)
      return filtro
    },
    carregarCard () {
      var self = this
      if (self.permissaoHome === 'T') {
        utilHttp.httpGetCarregando(api.ABERTURA_PROCESSO_BUSCAR_QUANTIDADE, resposta => {
          if (resposta.status === 200) {
            self.qtdProcessosAbertoHoje = resposta.body.qtdProcessosAbertoHoje
            self.qtdProcessosAbertoViaBalcao = resposta.body.qtdProcessosAbertoViaBalcao
            self.qtdSolicitacaoProcesso = resposta.body.qtdSolicitacaoQueVirouProcesso
          }
        })
      } else {
        let url = api.ABERTURA_PROCESSO_BUSCAR_QUANTIDADE_PERMISSAO.concat('/').concat(self.$login.getCodUsuario())
        utilHttp.httpGetCarregando(url, resposta => {
          if (resposta.status === 200) {
            self.qtdProcessosAbertoHoje = resposta.body.qtdProcessosAbertoHoje
            self.qtdProcessosAbertoViaBalcao = resposta.body.qtdProcessosAbertoViaBalcao
            self.qtdSolicitacaoProcesso = resposta.body.qtdSolicitacaoQueVirouProcesso
          }
        })
      }
    },
    pesquisarTodos () {
      this.indTipoBusca = ''
      this.$refs['refResultadoPesquisaAberturaProcesso'].pesquisar(1)
    },
    pesquisarAbertosHoje () {
      this.indTipoBusca = 'ABERTOHOJE'
      this.$refs['refResultadoPesquisaAberturaProcesso'].pesquisar(1)
    },
    pesquisarSolicitacaoProcesso () {
      this.indTipoBusca = 'SOLICITACAOPROCESSO'
      this.$refs['refResultadoPesquisaAberturaProcesso'].pesquisar(1)
    },
    pesquisarViaBalcao () {
      this.indTipoBusca = 'VIABALCAO'
      this.$refs['refResultadoPesquisaAberturaProcesso'].pesquisar(1)
    },
    limparFiltros () {
      this.termo = ''
      this.limparFiltro()
    },
    limparFiltro () {
      var self = this
      self.elementosPorPagina = 10
      self.pagina = 1
      self.StatusProcesso = 'TOD'
      self.aberturaProcesso.numProcesso = ''
      self.aberturaProcesso.requerente.codRequerente = ''
      self.$refs['refRequerente'].limpar()
      self.$refs['refResultadoPesquisaAberturaProcesso'].limpar()
      self.$refs['refResultadoPesquisaAberturaProcesso'].limparPaginacao()
      self.aberturaProcesso.requerente = {}
      self.situacao = {}
      self.aberturaProcesso = {
        requerente: {}
      }
      self.carregarCard()
    },
    getFiltroPesquisa () {
      var filtro = ''
      var self = this
      if (self.aberturaProcesso.numProcesso) filtro = filtro.concat('&numProcesso=').concat(self.aberturaProcesso.numProcesso)
      if (self.aberturaProcesso.requerente.codRequerente) filtro = filtro.concat('&codRequerente=').concat(self.aberturaProcesso.requerente.codRequerente)
      filtro = filtro.concat('&indTipoBusca=').concat(self.indTipoBusca)
      filtro = filtro.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      if (self.aberturaProcesso.txtNotaFiscal) filtro = filtro.concat('&txtNotaFiscal=').concat(self.aberturaProcesso.txtNotaFiscal)
      filtro = filtro.concat('&indPermissaoHome=').concat(self.permissaoHome)
      if (self.codSubassunto) filtro = filtro.concat('&codSubassunto=').concat(self.codSubassunto)
      if (self.codAssunto) filtro = filtro.concat('&codAssunto=').concat(self.codAssunto)
      return filtro
    },
    formatarDataAtualizacao (valor) {
      if (valor) {
        let hora = valor.substring(11, 16)
        let data = util.formatarData(valor, 'dd/mm/yyyy')
        return data + ' ' + hora
      } else {
        return ''
      }
    }
  },
  watch: {
    codSubassunto: {
      handler (valor) {
        var self = this
        if (valor) {
          if (self.$refs['refSubAssunto'].objetoSelecionado.codSubassunto) {
            if (!self.$refs['refAssunto'].objetoSelecionado.codAssunto) {
              let subassunto = self.$refs['refSubAssunto'].objetoSelecionado
              self.codAssunto = subassunto.assunto.codAssunto
              self.$refs['refAssunto'].carregar(subassunto.assunto.codAssunto, subassunto.assunto.desAssunto, subassunto.assunto)
            }
          }
        }
      }
    },
    codAssunto: {
      handler (valor) {
        var self = this
        if (!util.validarCampo(valor)) {
          self.$refs['refSubAssunto'].limpar()
        }
      }
    }
  },
  mounted () {
    var self = this
    self.paginaStatus.caminhoMigalha = [
      {
        icone: 'fa fa-home',
        descricao: 'Home',
        rotaNome: 'index'
      }
    ]
    utilHttp.httpGet(self.apiParametrosSistema, resposta => {
      if (resposta.body !== undefined && resposta.body !== '') {
        if (resposta.body.indPermissaoHome !== null) {
          self.permissaoHome = resposta.body.indPermissaoHome
        } else {
          self.permissaoHome = 'S'
        }
      } else {
        self.permissaoHome = 'S'
      }
      self.carregarCard()
    })
  },
  components: { GSelect, GInput, GAutocomplete, GFab, GDatatable, TelaMonitora, GBreadcrumb }
}

</script>

<style>
.termo {
  flex: 1;
}
</style>
